import { render, staticRenderFns } from "./SupervisedPersonsListModal.vue?vue&type=template&id=3ce3f703&scoped=true"
import script from "./SupervisedPersonsListModal.vue?vue&type=script&lang=js"
export * from "./SupervisedPersonsListModal.vue?vue&type=script&lang=js"
import style0 from "./SupervisedPersonsListModal.vue?vue&type=style&index=0&id=3ce3f703&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3f703",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce3f703')) {
      api.createRecord('3ce3f703', component.options)
    } else {
      api.reload('3ce3f703', component.options)
    }
    module.hot.accept("./SupervisedPersonsListModal.vue?vue&type=template&id=3ce3f703&scoped=true", function () {
      api.rerender('3ce3f703', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/SupervisedPersonsListModal.vue"
export default component.exports